import apiConfig from "../config/apiConfig";
import { apiFetch } from "../apis/apiFetch";

export type AdmissionDriveKind = "btech" | "mtech";

export async function resolveAdmissionDriveKind(
  userRaspId: string | undefined,
  driveId?: string | null,
): Promise<{ kind: AdmissionDriveKind | null; driveName: string | null; drive: any }> {
  if (!userRaspId) return { kind: null, driveName: null, drive: null };

  const [appRes, driveRes] = await Promise.all([
    apiFetch(
      `${apiConfig.getResourceUrl("applications")}?queryId=GET_APPLICATIONS_BY_USER_ID&args=user_id:${userRaspId}`,
    ),
    apiFetch(`${apiConfig.getResourceUrl("drive")}?queryId=GET_ALL`),
  ]);

  if (!appRes.ok || !driveRes.ok) return { kind: null, driveName: null, drive: null };

  const apps = (await appRes.json()).resource || [];
  const drives = (await driveRes.json()).resource || [];

  const app = driveId
    ? apps.find((a: any) => a.user_id === userRaspId && a.drive_id === driveId)
    : apps.find((a: { user_id?: string }) => a.user_id === userRaspId) || apps[0];

  if (!app?.drive_id) return { kind: null, driveName: null, drive: null };

  const drive = drives.find((d: { id?: string }) => d.id === app.drive_id);
  const driveName = drive?.name ?? null;
  const driveType = drive?.drivetype ?? null;
  if (!driveName) return { kind: null, driveName: null, drive: null };
  console.log("resolvekind", (driveType !== null) ? driveType?.toLowerCase() : null)
  return {
    kind: (driveType !== null) ? driveType?.toLowerCase() : null,
    driveName,
    drive
  };
}
